import { Component } from '@angular/core';
import { Item, Pallet, PalletCreation } from '../../domain/inventory.model';
import { ConfirmationService, MessageService } from 'primeng/api';
import { debounceTime, of, Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { InventoryService } from '../../services/inventory.service';
import { ImageService } from '../../services/image.service';
import { switchMap } from 'rxjs/operators';
import { MessageHomeService } from '../../services/message-home.service';

@Component({
    selector: 'app-palletize',
    templateUrl: './palletize.component.html',
    styleUrl: './palletize.component.scss',
    providers: [ConfirmationService],
    standalone: false
})
export class PalletizeComponent {
  palletCode: string = '';
  pallet: Pallet = {};
  scannedItems: Item[] = [];
  warehouse: string = '';
  accountId: number = 0;
  accountName: string = '';
  paletize: boolean = false;
  private articleSearchSubject = new Subject<string>();
  private palletSearchSubject = new Subject<string>();
  manualQrCode: string = '';
  manualPaletQrCode: string = '';

  // Upload images
  selectedImages: string[] = [];
  imagesToUpload: File[] = [];

  constructor(private messageService: MessageService, private imageService: ImageService,
    private inventoryService: InventoryService, private route: ActivatedRoute, private router: Router, private confirmationService: ConfirmationService,
    private messageHomeService: MessageHomeService
  ) {
    //this.warehouse = this.route.snapshot.paramMap.get('warehouse') || '';
    //this.accountId = Number(this.route.snapshot.paramMap.get('accountId'));
    this.articleSearchSubject.pipe(
      debounceTime(1000)
    ).subscribe(result => {
      this.onArticleScanSuccess(result);
    });
    this.palletSearchSubject.pipe(
      debounceTime(1000)
    ).subscribe(result => {
      this.onPalletScanSuccess(result);
    });
  }

  ngOnInit(): void {
    this.setHistoryState();
    this.route.queryParams.subscribe(params => {
      this.warehouse = params['warehouse'] || '';
      this.accountName = params['accountName'] ? params['accountName'] : '';
      this.accountId = params['accountId'] ? Number(params['accountId']) : 0;
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener('popstate', this.onClose.bind(this));
  }

  onManualInputChange() {
    this.articleSearchSubject.next(this.manualQrCode);
  }

  onManualPalletInputChange() {
    this.palletSearchSubject.next(this.manualPaletQrCode);
  }

  private setHistoryState(): void {
    history.pushState(null, '');
    window.addEventListener('popstate', this.onClose.bind(this));
  }

  openCamera() {
    const cameraInput = document.getElementById('cameraInput') as HTMLInputElement;
    cameraInput.click();
  }


  onPhotoSelected(event: any) {
    const files: FileList = event.target.files;
    if (files.length === 0) return;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageService.compressImage(file).then((compressedFile) => {
          this.selectedImages.push(e.target.result);
          this.imagesToUpload.push(compressedFile);
        });
      };
      reader.readAsDataURL(file);
    }
  }

  removeImage(index: number) {
    this.selectedImages.splice(index, 1);
    this.imagesToUpload.splice(index, 1);
  }

  onArticleScan(qrCode: string) {
    this.articleSearchSubject.next(qrCode);
  }

  onPalletScanSuccess(palletCode: string) {
    this.manualPaletQrCode = '';
    this.playSound();
    if (this.palletCode) {
      this.messageService.add({ severity: 'warn', summary: 'Palet ya asignada', detail: 'El pallet ya tiene un código asignado' });
      return;
    }

    this.inventoryService.getExistingPallet(this.warehouse, this.accountId, palletCode).subscribe((pallet: Pallet) => {
      if (pallet.palletId) {
        this.palletCode = palletCode;
        this.pallet = pallet;
        this.messageService.add({ severity: 'success', summary: 'Escaneado', detail: 'Código de Pallet agregado' });
      } else {
        this.router.navigate(['/pallet-scanner'], {
          queryParams: {
            warehouse: this.warehouse,
            accountId: this.accountId,
            palletCode: palletCode
          },
          state: { items: this.scannedItems }
        });
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error.message });
    });
  }

  onArticleScanSuccess(qrCode: string) {
    this.manualQrCode = '';
    this.playSound();
    if (this.scannedItems.some(item => item.code === qrCode)) {
      this.messageService.add({ severity: 'warn', summary: 'Código duplicado', detail: 'Este código ya esta en la lista' });
      return;
    }

    this.inventoryService.getExistingItem(this.warehouse, this.accountId, qrCode).subscribe((item: Item) => {
      if (item) {
        this.messageService.add({ severity: 'success', summary: 'Escaneado', detail: 'Código de artículo agregado' });
        this.scannedItems.push(item);
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error.message });
    });
  }

  playSound() {
    const audio = new Audio();
    audio.src = '../../assets/sounds/beepSound2.mp3';
    audio.load();
    audio.play();
  }

  resetPalletCode() {
    this.palletCode = '';
    this.pallet = {};
  }

  removeItem(index: number) {
    this.scannedItems.splice(index, 1);
  }

  onClose() {
    this.confirmationService.confirm({
      message: '¿Quieres cancelar el Paletizado?',
      header: 'Confirmación',
      acceptLabel: 'Sí',
      rejectLabel: 'No',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        window.removeEventListener('popstate', this.onClose.bind(this));
        this.router.navigate(['/home/inventory/articles']);
        //this.location.back();
      },
      reject: () => {
        history.pushState(null, '');
      },
    });
  }

  onSave() {
    if (!this.pallet) {
      this.messageService.add({ severity: 'error', summary: 'Código requerido', detail: 'Escanea el código del Pallet antes de guardar' });
      return;
    }

    const payload: PalletCreation = {
      pallet: this.pallet,
      items: this.scannedItems
    };

    this.inventoryService.moveOrPalletizeItems(payload)
      .pipe(
        switchMap(() => {
          const files: File[] = this.imagesToUpload || [];
          if (files.length > 0) {
            return this.imageService.uploadImages(files, this.pallet.palletId || '');
          }
          return of(null);
        })
      ).subscribe(() => {
        this.resetPalletCode();
        this.messageHomeService.showSuccessAndNavigate(
          this.router,
          '/mobile/menu',
          'Paletizado completado',
          'Los artículos fueron Paletizados'
        );
      }, resp => {
        console.error('Error creating the pallet', resp);
        this.messageService.add({ severity: 'error', summary: resp.error.message });
      });
  }

}
